import React, { FC } from 'react';
import { Notification as NotificationInterface } from '../../../../../interfaces/Notification';
import Notification from './Notification';
import { StyledSection, StyledSectionTitle } from './Section.styles';

export interface SectionProps {
  notifications: NotificationInterface[];
  title: string;
}

const Section: FC<SectionProps> = ({ notifications, title, ...props }) => {
  if ((notifications?.length ?? 0) === 0) return null;
  return (
    <StyledSection {...props}>
      <StyledSectionTitle>{title}</StyledSectionTitle>
      {notifications.map((n, i) => <Notification key={n.id} notification={n} index={i} />)}
    </StyledSection>
  );
};
export default Section;
